// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_C4Rgh {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 300px;
    min-width: 160px;
    height: 100%;
    gap: 2px;
    overflow-y: scroll;
    overflow-x: hidden;
    background: var(--f5-background);
    border-left: none;


    &::-webkit-scrollbar {
        display: none;
    }

    .workspaceContainer_eIPwP {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 4px;
        width: 100%;
        padding: 10px;

        /* border-bottom: 1px solid #e0e0e0; */
        >div {
            width: 26px;
            height: 26px;
            min-width: 26px;
            display: flex;
            align-items: center;
            margin-left: 6px;
            border-radius: 8px;
            overflow: hidden;

            svg {
                width: 26px;
                height: 26px;
            }
        }

        b {
            font-size: 12px;
            font-weight: 500;
            color: var(--black-color);
        }

        svg {
            width: 18px;
            height: 18px;
        }
    }

    .menuSections_odKv3 {
        width: 92%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 2px;
        border-bottom: 1px solid var(--e0e0e0-background);
        padding: 4px 12px;

        &:last-child {
            border-bottom: none;
        }

        .menuItem__bd4m {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 8px;
            width: 100%;
            border-radius: 10px;
            padding: 4px 10px;
            cursor: pointer;
            transition: all 0.3s ease;
            border-radius: 15px;
            font-size: 12px;
            padding: 6px 0px;
            margin-left: -4px;

            &:hover {
                background-color: var(--fa-background);
            }

            label {
                font-size: 10px;
                color: var(--d9d9e3-border);
                margin-left: auto;
                background: red;
                margin: 0px;
                margin-left: auto;
                padding: 2px 4px;
                font-size: 8px;
                border-radius: 10px;
                font-size: 8px;
            }

            .menuItemIcon_M3ypy {
                width: 36px;
                height: 36px;
                min-width: 36px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                /* background: red; */
                border-radius: 6px;

                
            

                svg {
                    width: 21px;
                    height: 21px;
                    position: relative;
                    /* fill: var(--_030303-color);
                    color: var(--_030303-color); */
                }

                label{
                        position: absolute;
    bottom: 0;
    right: 0;
                }

            }
            .tablesIcon__WNpM{
                svg{
                /* fill: var(--_0b745a-background);
                color: var(--_0b745a-background); */
                }
            }
        }
    }

    &.activeTab_vYbY2 {
        border-left: none;
        background: linear-gradient(to top, var(--white-color) 0%, var(--white-color) 43%, var(--f5-background) 100%);
        min-width: 50px;
        max-width: 50px;

        .workspaceContainer_eIPwP {
            padding: 0px;
            margin-top: 6px;

            >div {
                margin-left: 3px;
                margin-bottom: -2px;
            }
        }

        .menuSections_odKv3 {
            width: 30px;
            max-width: 30px;

            .menuItem__bd4m {
                padding: 5px 10px;

                span {
                    display: none;
                }
            }
        }


        .menuItemIcon_M3ypy {
            &:hover{
                background: var(--f5-background);
            }
        }
    }

    &.isTransparent_BZj4y {
        background: transparent;
        border: none;
    }
}




.tooltip_IT5fb {
    display: none;
    background: #000;
    color: #fff;
    font-size: 12px;
    padding: 2px 5px;
    border-radius: 6px;
    transform: translateY(-200%);

    &::after {
        content: "";
        position: absolute;
        top: calc(50% - 5px);
        /* transform: translateY(-100%); */
        right: calc(100% - 1px);
        border: 5px solid transparent;
        border-bottom-color: #000000;
        /* transform: translateX(-50%); */
        /* border-bottom-color: var(--_000000cc-background); */
        /* opacity: 0; */
        /* visibility: hidden; */
        transition: all 0.3s ease;
        transform: rotate(-90deg);
        z-index: 111;
    }

}

.tooltip_IT5fb {
    &.active_EDO02 {
        display: inline-flex !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/HomeExplorer/HomeExplorer.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,iBAAiB;;;IAGjB;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,2BAA2B;QAC3B,QAAQ;QACR,WAAW;QACX,aAAa;;QAEb,sCAAsC;QACtC;YACI,WAAW;YACX,YAAY;YACZ,eAAe;YACf,aAAa;YACb,mBAAmB;YACnB,gBAAgB;YAChB,kBAAkB;YAClB,gBAAgB;;YAEhB;gBACI,WAAW;gBACX,YAAY;YAChB;QACJ;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,yBAAyB;QAC7B;;QAEA;YACI,WAAW;YACX,YAAY;QAChB;IACJ;;IAEA;QACI,UAAU;QACV,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,QAAQ;QACR,iDAAiD;QACjD,iBAAiB;;QAEjB;YACI,mBAAmB;QACvB;;QAEA;YACI,kBAAkB;YAClB,aAAa;YACb,mBAAmB;YACnB,2BAA2B;YAC3B,QAAQ;YACR,WAAW;YACX,mBAAmB;YACnB,iBAAiB;YACjB,eAAe;YACf,yBAAyB;YACzB,mBAAmB;YACnB,eAAe;YACf,gBAAgB;YAChB,iBAAiB;;YAEjB;gBACI,sCAAsC;YAC1C;;YAEA;gBACI,eAAe;gBACf,2BAA2B;gBAC3B,iBAAiB;gBACjB,eAAe;gBACf,WAAW;gBACX,iBAAiB;gBACjB,gBAAgB;gBAChB,cAAc;gBACd,mBAAmB;gBACnB,cAAc;YAClB;;YAEA;gBACI,WAAW;gBACX,YAAY;gBACZ,eAAe;gBACf,aAAa;gBACb,mBAAmB;gBACnB,uBAAuB;gBACvB,kBAAkB;gBAClB,qBAAqB;gBACrB,kBAAkB;;;;;gBAKlB;oBACI,WAAW;oBACX,YAAY;oBACZ,kBAAkB;oBAClB;kDAC8B;gBAClC;;gBAEA;wBACQ,kBAAkB;IACtC,SAAS;IACT,QAAQ;gBACI;;YAEJ;YACA;gBACI;gBACA;mDACmC;gBACnC;YACJ;QACJ;IACJ;;IAEA;QACI,iBAAiB;QACjB,6GAA6G;QAC7G,eAAe;QACf,eAAe;;QAEf;YACI,YAAY;YACZ,eAAe;;YAEf;gBACI,gBAAgB;gBAChB,mBAAmB;YACvB;QACJ;;QAEA;YACI,WAAW;YACX,eAAe;;YAEf;gBACI,iBAAiB;;gBAEjB;oBACI,aAAa;gBACjB;YACJ;QACJ;;;QAGA;YACI;gBACI,gCAAgC;YACpC;QACJ;IACJ;;IAEA;QACI,uBAAuB;QACvB,YAAY;IAChB;AACJ;;;;;AAKA;IACI,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;;IAE5B;QACI,WAAW;QACX,kBAAkB;QAClB,oBAAoB;QACpB,kCAAkC;QAClC,uBAAuB;QACvB,6BAA6B;QAC7B,4BAA4B;QAC5B,iCAAiC;QACjC,sDAAsD;QACtD,gBAAgB;QAChB,wBAAwB;QACxB,yBAAyB;QACzB,yBAAyB;QACzB,YAAY;IAChB;;AAEJ;;AAEA;IACI;QACI,+BAA+B;IACnC;AACJ","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 300px;\n    min-width: 160px;\n    height: 100%;\n    gap: 2px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    background: var(--f5-background);\n    border-left: none;\n\n\n    &::-webkit-scrollbar {\n        display: none;\n    }\n\n    .workspaceContainer {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        gap: 4px;\n        width: 100%;\n        padding: 10px;\n\n        /* border-bottom: 1px solid #e0e0e0; */\n        >div {\n            width: 26px;\n            height: 26px;\n            min-width: 26px;\n            display: flex;\n            align-items: center;\n            margin-left: 6px;\n            border-radius: 8px;\n            overflow: hidden;\n\n            svg {\n                width: 26px;\n                height: 26px;\n            }\n        }\n\n        b {\n            font-size: 12px;\n            font-weight: 500;\n            color: var(--black-color);\n        }\n\n        svg {\n            width: 18px;\n            height: 18px;\n        }\n    }\n\n    .menuSections {\n        width: 92%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 2px;\n        border-bottom: 1px solid var(--e0e0e0-background);\n        padding: 4px 12px;\n\n        &:last-child {\n            border-bottom: none;\n        }\n\n        .menuItem {\n            position: relative;\n            display: flex;\n            align-items: center;\n            justify-content: flex-start;\n            gap: 8px;\n            width: 100%;\n            border-radius: 10px;\n            padding: 4px 10px;\n            cursor: pointer;\n            transition: all 0.3s ease;\n            border-radius: 15px;\n            font-size: 12px;\n            padding: 6px 0px;\n            margin-left: -4px;\n\n            &:hover {\n                background-color: var(--fa-background);\n            }\n\n            label {\n                font-size: 10px;\n                color: var(--d9d9e3-border);\n                margin-left: auto;\n                background: red;\n                margin: 0px;\n                margin-left: auto;\n                padding: 2px 4px;\n                font-size: 8px;\n                border-radius: 10px;\n                font-size: 8px;\n            }\n\n            .menuItemIcon {\n                width: 36px;\n                height: 36px;\n                min-width: 36px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                position: relative;\n                /* background: red; */\n                border-radius: 6px;\n\n                \n            \n\n                svg {\n                    width: 21px;\n                    height: 21px;\n                    position: relative;\n                    /* fill: var(--_030303-color);\n                    color: var(--_030303-color); */\n                }\n\n                label{\n                        position: absolute;\n    bottom: 0;\n    right: 0;\n                }\n\n            }\n            .tablesIcon{\n                svg{\n                /* fill: var(--_0b745a-background);\n                color: var(--_0b745a-background); */\n                }\n            }\n        }\n    }\n\n    &.activeTab {\n        border-left: none;\n        background: linear-gradient(to top, var(--white-color) 0%, var(--white-color) 43%, var(--f5-background) 100%);\n        min-width: 50px;\n        max-width: 50px;\n\n        .workspaceContainer {\n            padding: 0px;\n            margin-top: 6px;\n\n            >div {\n                margin-left: 3px;\n                margin-bottom: -2px;\n            }\n        }\n\n        .menuSections {\n            width: 30px;\n            max-width: 30px;\n\n            .menuItem {\n                padding: 5px 10px;\n\n                span {\n                    display: none;\n                }\n            }\n        }\n\n\n        .menuItemIcon {\n            &:hover{\n                background: var(--f5-background);\n            }\n        }\n    }\n\n    &.isTransparent {\n        background: transparent;\n        border: none;\n    }\n}\n\n\n\n\n.tooltip {\n    display: none;\n    background: #000;\n    color: #fff;\n    font-size: 12px;\n    padding: 2px 5px;\n    border-radius: 6px;\n    transform: translateY(-200%);\n\n    &::after {\n        content: \"\";\n        position: absolute;\n        top: calc(50% - 5px);\n        /* transform: translateY(-100%); */\n        right: calc(100% - 1px);\n        border: 5px solid transparent;\n        border-bottom-color: #000000;\n        /* transform: translateX(-50%); */\n        /* border-bottom-color: var(--_000000cc-background); */\n        /* opacity: 0; */\n        /* visibility: hidden; */\n        transition: all 0.3s ease;\n        transform: rotate(-90deg);\n        z-index: 111;\n    }\n\n}\n\n.tooltip {\n    &.active {\n        display: inline-flex !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_C4Rgh`,
	"workspaceContainer": `workspaceContainer_eIPwP`,
	"menuSections": `menuSections_odKv3`,
	"menuItem": `menuItem__bd4m`,
	"menuItemIcon": `menuItemIcon_M3ypy`,
	"tablesIcon": `tablesIcon__WNpM`,
	"activeTab": `activeTab_vYbY2`,
	"isTransparent": `isTransparent_BZj4y`,
	"tooltip": `tooltip_IT5fb`,
	"active": `active_EDO02`
};
export default ___CSS_LOADER_EXPORT___;
